// extracted by mini-css-extract-plugin
export var adjacentSlide = "_oe-9";
export var arrowButtonContainer = "_oe-5";
export var arrowButtonIcon = "_oe-6";
export var carouselArrowButton = "_oe-2";
export var carouselElementContainer = "_oe-1";
export var currentSlide = "_oe-8";
export var left = "_oe-3";
export var otherSlide = "_oe-a";
export var productCarouselContainer = "_oe-0";
export var right = "_oe-4";
export var sliderOverflow = "_oe-7";